import { Injectable } from '@angular/core';
import { BaseService } from '@core/service/base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ClaimDtService extends BaseService{

  private url = "api/claim-dt";

  constructor(http: HttpClient) {
    super(http);
  }

  getUrl(){
    return this.url;
  }

  /**
   * 通过未处理的其他费用明细
   */
  getClaimDtByCondition(flowState,companyCode,supplierId):Observable<any> {
    return this.http.get<any>(this.url+"/getByCondition?flowState="+flowState+
      "&companyCode="+companyCode+"&supplierId="+supplierId).pipe(
      tap(_ => this.log(`fetched object companyCode=${companyCode} and supplierId = ${supplierId}`)),
      catchError(this.handleError<any>(`getany companyCode=${companyCode} and supplierId = ${supplierId}`))
    );
  }
  updateClaimDt(id,used,type) {
    return this.http.get<any>(this.url+"/updateClaimDt?id="+id+"&used="+used+"&type="+type);
  }
}
